"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorCustom = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@usereactify/search-internals/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const props_1 = require("../../utility/props");
const SensorCustom = () => {
    const reactifySearchContext = (0, hooks_1.useReactifySearchContext)();
    const reactiveProps = (0, props_1.getPropsSensorCustom)({
        config: reactifySearchContext.config,
        provider: reactifySearchContext.options,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, reactiveProps.map((props, index) => react_1.default.createElement(ReactiveComponent_1.default, Object.assign({ key: `SensorCustom_${index}` }, props)))));
};
exports.SensorCustom = SensorCustom;
//# sourceMappingURL=SensorCustom.js.map